import redirectPermanently from '@/components/Redirect/redirectPermanently';

const Payment = () => redirectPermanently('//tienda.aibes.org');

export default Payment;
